import React from 'react';
import { TagsTable } from './TagsTable';
import WelcomeBannerHome from '../../Components/home/WelcomeBannerHome';
import SideBar from '../../Components/home/SideBar';
import { CondorStandardTags } from '../../Components/manage-tags/CondorStandardTags';
import CondorSpinner from '../../Components/CondorSpinner';
import { useQuery } from '@tanstack/react-query';
import { getTagByName } from '../../services/TagsService';
import { useApiClient } from '../../hooks/useApiClient';

export const ManageTagsPage = () => {
  const { token } = useApiClient();
  const { data: purpleData, isPending: purpleLoading } = useQuery({
    queryKey: ['purpleTag'],
    queryFn: async () => getTagByName('purple'),
    enabled: !!token,
  });

  const purpleDeviceTag = {
    tagId: purpleData?.tagId ?? '',
    tagName: purpleData?.tagName ?? '',
    enabled: !!token,
  };

  const { data: yellowData, isPending: yellowLoading } = useQuery({
    queryKey: ['yellowTag'],
    queryFn: async () => getTagByName('yellow'),
    enabled: !!token,
  });

  const yellowDeviceTag = {
    tagId: yellowData?.tagId ?? '',
    tagName: yellowData?.tagName ?? '',
  };

  return (
    <div style={{ paddingBottom: '5%' }}>
      <WelcomeBannerHome subtitle="Let's manage some tags and stuff" />
      <div style={{ display: 'flex' }}>
        <div style={{ flexBasis: '20%' }}>
          <SideBar />
        </div>
        <div style={{ flexBasis: '80%' }}>
          {purpleLoading || yellowLoading ? (
            <CondorSpinner />
          ) : (
            <>
              <CondorStandardTags
                purpleTag={purpleDeviceTag}
                yellowTag={yellowDeviceTag}
              />
              <TagsTable
                purpleTag={purpleDeviceTag}
                yellowTag={yellowDeviceTag}
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
};
